export default __webpack_public_path__ + "static/media/13.b1e44545.webp";